import { InjectionToken } from '@angular/core';

import { ILicensingService } from './licensing.type';

export const LICENSING_SERVICE: InjectionToken<ILicensingService> = new InjectionToken<ILicensingService>('LICENSING_SERVICE');
